<template>

    <animated-background>
        <v-dialog persistent transition="scale-transition" max-width="450" v-model="dialog">

            <!-- Ask for user's email address -->
            <v-card dark v-show="!showResponse">
                <v-toolbar dense color="grey darken-4" dark>
                    <v-toolbar-title>Reset password</v-toolbar-title>
                </v-toolbar>

                <v-card-text class="mt-4">

                    <p>Please enter your email address. We will email you a password reset link.</p>

                    <validation-observer ref="validationObserver" v-slot="{ errors }">

                        <validation-provider
                            mode="lazy"
                            name="email address"
                            rules="required|email|max:100"
                            v-slot="{ errors }">

                            <v-text-field
                                label="Email address"
                                v-model="data.email"
                                required
                                prepend-icon="mdi-at"
                                :error-messages="errors"
                                @keyup.enter="enterPressed"
                            ></v-text-field>
                        </validation-provider>

                    </validation-observer>

                    <v-alert type="error"
                             v-show="throttleSecondsRemaining>0"
                             class="body-2"
                             icon="mdi-alert"
                             v-text="throttleError"
                    ></v-alert>

                </v-card-text>
                <v-card-actions>
                    <v-btn class="ml-2 mb-2"
                           :disabled="submitDisabled"
                           color="primary"
                           :loading="sending"
                           @click="submitForm">Send
                    </v-btn>
                    <v-btn text class="ml-2 mb-2" @click="cancel">Cancel</v-btn>
                </v-card-actions>

            </v-card>

            <!-- Show response card -->
            <v-card v-show="showResponse">
                <v-toolbar dense color="grey darken-4" flat dark>
                    <v-toolbar-title>Reset Password</v-toolbar-title>
                </v-toolbar>
                <v-card-text class="d-flex mt-5">
                    <div class="align-self-center">
                        <v-icon x-large class="mr-4">mdi-email-check</v-icon>
                    </div>
                    <div class="align-self-center">
                        <div>Password reset email sent!</div>
                    </div>
                </v-card-text>

                <v-card-text>
                    <v-btn class="mt-3" color="primary" @click="goToLogin">Go to login</v-btn>
                </v-card-text>

            </v-card>

        </v-dialog>
    </animated-background>
</template>

<script>

import {throttleTimer} from '../../../components/mixins/throttleTimer';
import {emailValidationRules} from '../../../components/mixins/emailValidationRulesMixin';
import Form from '../../../components/forms/Form';
import axios from 'axios';
import AnimatedBackground from "../../../components/UI/AnimatedBackground";

export default {
    components: {AnimatedBackground},
    mixins: [throttleTimer, emailValidationRules],

    data() {
        return {
            data: {
                email: null,
            },
            dialog: true,
            showForm: true,
            showResponse: false,
            submitDisabled: false,
            formValid: false,
            sending: false,
        }
    },

    mounted() {
        setTimeout(() => {
            this.dialog = true;
        }, 200);
    },

    watch: {
        // Needed for routing back into this component due to the timeout
        $route(to, from) {
            if (to.path === '/spa/password-reset') {
                this.dialog = true;
                this.showResponse = false;
            }
        }
    },

    methods: {
        cancel() {
            this.goToLogin();
        },

        enterPressed(message, event) {

            this.$nextTick(() => {
                this.submitForm();
            })
        },

        goToLogin() {
            this.$router.push('/spa/login');
            this.dialog = false;
            setTimeout(() => {
                this.showResponse = false;
            }, 1000);
        },

        submitForm() {
            this.$refs.validationObserver.validate()
                .then(isValid => {

                    if (isValid) {
                        this.sending = true;

                        axios.post('/password/email', this.data)
                            .catch(({response}) => {

                                if (response.status === 429) {

                                    this.startThrottleTimer(() => {
                                        this.submitDisabled = false;
                                    }, 60);
                                }
                            })
                            .then(({response}) => {
                                this.showForm = false;
                                this.showResponse = true;
                            })
                            .finally(() => {
                                this.sending = false;
                            });
                    }
                });
        },
    }
}
</script>
